import { useNavigate } from "react-router-dom";
import { useState } from "react";
import useTodayTrialLessons from "../../../hooks/useTodayTrialLessons";
import { useTodayZeroLessons } from "../../../hooks/useTodayZeroLessons";
import useMissingLessons from '../../../hooks/useMissingLessons'
import * as styled from "./AdminBlock.styled";

function AdminBlock() {
  const { todayLessons, loading } = useTodayZeroLessons();
  const { trialLessons, trialLoading } = useTodayTrialLessons();
  const { missingLessons, loading: missingLoading } = useMissingLessons();
  const navigate = useNavigate();

  const [filter, setFilter] = useState("all");

  const filterLessons = (lessons) => {
    return lessons.filter((lesson) => {
      if (!lesson.time) return true;
      const hour = parseInt(lesson.time.split(":")[0]);
      if (filter === "morning") return hour < 14;
      if (filter === "evening") return hour >= 14;
      return true;
    });
  };

  const isLessonInPast = (timeStr) => {
    if (!timeStr) return false;
    const [h, m] = timeStr.split(":").map(Number);
    const now = new Date();
    const lessonTime = new Date();
    lessonTime.setHours(h, m, 0, 0);
    return now > lessonTime;
  };
  
  return (
    <styled.Wrapper>
      <styled.RegularLessonsCard>
        <styled.BlockTitle>📅 Уроки на сьогодні (0 оплат)</styled.BlockTitle>

        <styled.Filters>
          <styled.FilterButton onClick={() => setFilter("all")} $active={filter === "all"}>
            Усі
          </styled.FilterButton>
          <styled.FilterButton onClick={() => setFilter("morning")} $active={filter === "morning"}>
            Ранкові
          </styled.FilterButton>
          <styled.FilterButton onClick={() => setFilter("evening")} $active={filter === "evening"}>
            Вечірні
          </styled.FilterButton>
        </styled.Filters>

        {loading ? (
          <styled.Loading>Завантаження...</styled.Loading>
        ) : todayLessons.length === 0 ? (
          <styled.NoLessons>
            Сьогодні немає учнів з нульовим балансом
          </styled.NoLessons>
        ) : (
          filterLessons(todayLessons).map((lesson, index) => (
            <styled.LessonItem key={index}>
              <styled.LessonHeader>
                <styled.StudentName
                  title={`Оплачено уроків: ${lesson.totalLessons || 0}`}
                >
                  {lesson.name}
                </styled.StudentName>
                 <styled.Time>
                  {lesson.time}
                 
                </styled.Time>
              </styled.LessonHeader>
              <styled.Teacher
                onClick={() =>
                  navigate(`/admin/ourteachers/${lesson.teacherId}`)
                }
              >
                Викладач: {lesson.teacher}
              </styled.Teacher>
            </styled.LessonItem>
          ))
        )}
      </styled.RegularLessonsCard>

      <styled.TrialLessonsCard>
        <styled.BlockTitle>📌 Пробні уроки на сьогодні</styled.BlockTitle>

        {trialLoading ? (
          <styled.Loading>Завантаження...</styled.Loading>
        ) : trialLessons.length === 0 ? (
          <styled.NoLessons>Сьогодні немає пробних уроків</styled.NoLessons>
        ) : (
          trialLessons.map((lesson, index) => (
            <styled.LessonItem key={index}>
              <styled.LessonHeader>
                <styled.StudentName>{lesson.name}</styled.StudentName>
                <styled.Time>
                  {lesson.time}
                  {/* {isLessonInPast(lesson.time) && (
                    <styled.Tag variant="past">✅ Проведено</styled.Tag>
                  )} */}
                </styled.Time>
              </styled.LessonHeader>
              <styled.Teacher
                onClick={() =>
                  navigate(`/admin/ourteachers/${lesson.teacherId}`)
                }
              >
                Викладач: {lesson.teacher} ({lesson.teacherSchoolId})
              </styled.Teacher>
            </styled.LessonItem>
          ))
        )}
      </styled.TrialLessonsCard>

      {/* <styled.MissingLessonsCard>
        <styled.BlockTitle>⚠️ Відсутні відмітки за вчора</styled.BlockTitle>
        {missingLoading ? (
          <styled.Loading>Завантаження...</styled.Loading>
        ) : missingLessons.length === 0 ? (
          <styled.NoLessons>Усі уроки за вчора відмічені ✅</styled.NoLessons>
        ) : (
          missingLessons.map((lesson, index) => (
            <styled.LessonItem key={index}>
              <styled.LessonHeader>
                <styled.StudentName>{lesson.studentName}</styled.StudentName>
                <styled.Time>{lesson.time}</styled.Time>
              </styled.LessonHeader>
              <styled.Teacher onClick={() =>
                navigate(`/admin/ourteachers/${lesson.teacherId}`)
              }>
                Викладач: {lesson.teacher}
              </styled.Teacher>
            </styled.LessonItem>
          ))
        )}
      </styled.MissingLessonsCard> */}

    </styled.Wrapper>
  );
}

export default AdminBlock;
